import _ from 'lodash'

import config from '@config'

import {
    PERSONS_END_USERS_TABLE_CHANGE,
    PERSONS_END_USERS_TABLE_CHANGE_REQUEST,
    PERSONS_END_USERS_TABLE_LOADING_TRUE,
    PERSONS_END_USERS_TABLE_LOADING_FALSE,
    PERSONS_END_USERS_TABLE_DATA_RECEIVED,
} from './constants'

export function personsEndUsersTableChange(module, blockKey, id, level, queryParams) {
    return {
        type: PERSONS_END_USERS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            queryParams,
        },
    }
}

export function personsEndUsersTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: PERSONS_END_USERS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.report.${blockKey}.block[2].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function personsEndUsersTableDataReceived(module, id, blockKey, customData) {
    return {
        type: PERSONS_END_USERS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function personsEndUsersTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: PERSONS_END_USERS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function personsEndUsersTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: PERSONS_END_USERS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
